import React from "react";
import { WeaDialog, WeaLocaleProvider, WeaTab, WeaSelect } from "ecCom";
import { toJS } from "mobx";
import { Button } from "antd";
import { inject, observer } from "mobx-react";
import SystemSetTable from "../components/systemSetTable";
const getLabel = WeaLocaleProvider.getLabel;

// @inject("systemSetStore")
@observer
class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 490
    };
  }
  componentDidMount() {
    const { systemSetStore } = this.props.systemSetStore;
    systemSetStore.getModuleOptions();
    systemSetStore.getSystemSetTable({ moduleid: "" });
  }

  render() {
    if (!this.props.systemSetStore) {
      return null;
    }
    const { systemSetStore } = this.props.systemSetStore;
    const { loading, moduleOptions } = systemSetStore;
    const { height } = this.state;
    return (
      <div>
        <WeaDialog
          style={{ width: 720, height: 627 }}
          visible={this.props.visible}
          onCancel={() => this.props.onCancel()}
          title={getLabel(21946, "系统提醒设置")}
          loading={loading}
          icon={"icon-coms-Flow-setting"}
          onChangeHeight={h => {
            this.setState({ height: h - 85 });
          }}
          iconBgcolor="#407008"
          buttons={[
            <Button
              type="primary"
              onClick={() => {
                systemSetStore.saveConfig2DB(this.props.getMsgTypeList);
                this.props.onCancel();
              }}
            >
              {getLabel(86, "保存")}
            </Button>,
            <Button type="ghost" onClick={() => this.props.onCancel()}>
              {getLabel(201, "取消")}
            </Button>
          ]}
        >
          <WeaTab
            buttons={[
              <WeaSelect
                options={moduleOptions}
                style={{ width: 100 }}
                fieldshowtypes={3}
                widthMatchOptions={false}
                onChange={(v, showname) => {
                  systemSetStore.changeModuleValue(v);
                }}
              />
            ]}
          />
          <SystemSetTable tableStore={systemSetStore} height={height} />
        </WeaDialog>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/systemSet.js